"use client";

import { useTranslations } from "next-intl";

import { SubmitButton } from "~/components/submit-button";
import { Input } from "~/components/ui/input";
import { useRouter } from "~/navigation";

function getQuery(formData: FormData) {
  const formQuery = formData.get("query");
  if (typeof formQuery !== "string") {
    return null;
  }
  const query = formQuery.trim();
  if (query.length < 2) {
    return null;
  }
  return query;
}

export function SearchForm({
  searchParamsQuery,
}: {
  searchParamsQuery: string;
}) {
  const router = useRouter();
  const t = useTranslations("Articles");
  const tCommon = useTranslations("Common");
  return (
    <form
      className="grid grid-cols-[1fr_auto] gap-2"
      onSubmit={(event) => {
        event.preventDefault();
        const search = getQuery(new FormData(event.currentTarget));
        if (!search) {
          router.push(
            {
              pathname: "/blog",
              query: undefined,
            },
            { scroll: false },
          );
          return;
        }
        router.push(
          {
            pathname: "/blog",
            query: { query: search },
          },
          { scroll: false },
        );
      }}
    >
      <Input
        className="rounded-full"
        placeholder={t("searchPlaceholder")}
        defaultValue={searchParamsQuery}
        name="query"
      />
      <SubmitButton variant="sunset">{tCommon("search")}</SubmitButton>
    </form>
  );
}
